import React from "react";
import { Navigation } from "../components/layout";
import {
    Header,
    KickCalendar,
    About,
    Modus,
    Gallery,
    Contact
} from "../components/sections";
import AktuellesTeaser from "../components/sections/AktuellesTeaser";
import landingPageData from "../data/data.js";
import SmoothScroll from "smooth-scroll";
import { SMOOTH_SCROLL_CONFIG } from "../constants/config";
import "../App.css";

export const scroll = new SmoothScroll('a[href*="#"]', SMOOTH_SCROLL_CONFIG);

const Home = () => {
    return (
            <div>
                <Navigation />
                <Header data={landingPageData.Header} />
                <AktuellesTeaser />
                <KickCalendar />
                <Modus data={landingPageData.Modus} />
                <About />
                <Gallery />
                <Contact data={landingPageData.Contact} />
            </div>
    );
};

export default Home;